import React from 'react'

const OfferCreateUnit = ({record}) => {

    const style = {marginBottom: '24px'};

    return(
        <React.Fragment>
            {
                record.data ? <p style={style}>{record.data.unit}</p> : <p style={style}>-</p>
            }
        </React.Fragment>
    )
}
export default OfferCreateUnit